import { useEffect } from "react";

import loadingGif from "../assets/gifs/lineLoading-ezgif.com-crop.gif";
import icon from "../assets/images/button-icon.svg";
import deactiveIcon from "../assets/images/deactiveIcon.svg";
import readnoticeicon from "../assets/images/readnoticeicon.svg";
import regenerateIcon from "../assets/images/regenerateIcon.svg";
import searchproicon from "../assets/images/searchproicon.svg";

//sample
{
  /* <div onClick={handleOtp} className="mt-5">
<Buttons   btnStyleparam={"mainbutton"} fontsize={"regular"}  bgcolor={"primary"} txtcolor={"primary"}  children={'عنوان دکمه'} lefticon={false} righticon={false} borders={'secondary'}/>
</div> */
}

const Buttons = ({
  isLoading,
  children,
  disabled,
  btnStyleparam,
  fontsize,
  bgcolor,
  txtcolor,
  lefticon,
  righticon,
  borders,
  bRadius,
  deactive,
  regenerate,
  readNotice,
  searchpro,
}) => {
  useEffect(() => {
    // ////console.log(isLoading, "log is loading");

    return () => {};
  }, [isLoading]);

  const text = "flex w-full justify-center items-center rounded-v-sm";

  //fonts
  let font = "";
  switch (fontsize) {
    case "regular":
      font =
        "text-title-xs-semibold sm:text-title-sm-semibold md:text-title-md-semibold lg:text-title-lg-semibold xl:text-title-2xl-semibold";
      break;
    case "dashboard":
      font = "2xl:text-title-lg-semibold";
      break;
    case "Ibam":
      font = "text-title-md-semibold";
      break;
    case "newbusiness":
      font = "text-title-xs-semibold";
      break;
    case "pagination":
      font = "text-title-2xs-semibold";
      break;
    default:
      break;
  }

  //bg-color
  let backgroundcolor = "";
  switch (bgcolor) {
    case "success":
      backgroundcolor = "bg-success-30";
      break;
    case "primary":
      backgroundcolor = "bg-secondary-100";
      break;
    case "tonal":
      backgroundcolor = "bg-[#CED3D9]";
      break;
    case "secondary":
    case "ghost":
    case "pressing":
      backgroundcolor = "";
      break;
    case "disable":
      backgroundcolor = "bg-neutral-20 cursor-default";
      break;
    default:
      break;
  }

  //textcolor
  let textcolor = "";
  switch (txtcolor) {
    case "primary":
      textcolor = "text-neutral-00";
      break;
    case "secondary":
    case "ghost":
    case "tonal":
    case "pressing":
      textcolor = "text-secondary-100";
      break;
    case "disable":
      textcolor = "text-neutral-40";
      break;
    case "error":
      textcolor = "text-error-90";
      break;
    default:
      break;
  }

  //border
  let border = "";
  switch (borders) {
    case "primary":
    case "ghost":
    case "disable":
    case "tonal":
      border = "";
      break;
    case "secondary":
    case "Pressing":
      border = "border-2 border-secondary-100";
      break;
    case "error":
      border = "border-2 border-error-90";
    default:
      break;
  }

  //borderradius
  let radius = "";
  switch (bRadius) {
    case "sm":
      radius = "rounded-v-sm";
      break;
    case "md":
      radius = "rounded-v-md";
      break;
    case "lg":
      radius = "rounded-v-lg";
      break;
    case "xl":
      radius = "rounded-v-xl";
      break;
  }

  return (
    <div className="h-full">
      {btnStyleparam === "mainbutton" ? (
        <button
          className={`${text} ${font} ${backgroundcolor} ${textcolor} ${border} ${radius} px-[10px] py-[6px] whitespace-nowrap h-full  disabled:bg-neutral-400 `}
          disabled={disabled}
        >
          {lefticon == true ? <img className="w-4 h-4" src={icon}></img> : null}
          {deactive == true ? <img className="w-6 h-6 ml-2" src={deactiveIcon}></img> : null}
          {regenerate == true ? <img className="w-6 h-6 ml-2" src={regenerateIcon}></img> : null}
          {readNotice == true ? (
            <img id="BGnotice" className="w-6 h-6 ml-2" src={readnoticeicon}></img>
          ) : null}

          {isLoading == true ? (
            <img height={30} width={30} src={loadingGif} alt="loading..."></img>
          ) : (
            children
          )}

          {righticon == true ? <img className="w-4 h-4" src={icon}></img> : null}
          {searchpro == true ? <img className="w-6 h-6 mr-2" src={searchproicon}></img> : null}
        </button>
      ) : null}
    </div>
  );
};

export default Buttons;
